import { Flex } from "antd";
import { PROJECT_INFO } from "utils/constants";

export default function Logo() {
  return (
    <Flex align="center" gap={12}>
      <img style={{ height: "48px" }} src={PROJECT_INFO.logo} alt={PROJECT_INFO.name} />
      {/* <Typography.Title level={4} style={{ margin: 0 }}>
        {PROJECT_INFO.name}
      </Typography.Title> */}
    </Flex>
  );
}
